import React from 'react';
import {
  Container,
  Heading,
  Info,
  Bold,
} from 'styles/pages/account-setting/subHeader';

const SubHeader = ({ user }) => (
  <Container>
    <Heading>Manage Account.</Heading>
    <Info>
      You're logged in as <Bold>{user?.User?.Email}</Bold>
    </Info>
  </Container>
);

export default SubHeader;
